import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { get } from '../../utils/api'
import ReportTable from './ReportTable'
import styles from '../../styles/gri/report.module.css'

const GRI2021 = () => {
  const { id } = useParams()
  const [data, setData] = useState(null)
  const [reportingPeriodData, setReportingPeriodData] = useState(null)
  const [restatementsData, setRestatementsData] = useState(null)
  const [externalAssuranceData, setExternalAssuranceData] = useState(null)
  const [activitiesValueChainData, setActivitiesValueChainData] = useState(null)
  const [employeesData, setEmployeesData] = useState(null)
  const [nonEmployeeWorkersData, setNonEmployeeWorkersData] = useState(null)
  const [governanceStructureData, setGovernanceStructureData] = useState(null)
  const [nominationSelectionData, setNominationSelectionData] = useState(null)
  const [chairExecPositionData, setChairExecPositionData] = useState(null)
  const [governanceBodyRoleInStrategyData, setGovernanceBodyRoleInStrategyData] = useState(null)
  const [delegationData, setDelegationData] = useState(null)
  const [governanceBodyRoleData, setGovernanceBodyRoleData] = useState(null)
  const [conflictsOfInterestData, setConflictsOfInterestData] = useState(null)
  const [criticalConcernsData, setCriticalConcernsData] = useState(null)
  const [measuresToEnhanceKnowledgeData, setMeasuresToEnhanceKnowledgeData] = useState(null)
  const [performanceEvaluationData, setPerformanceEvaluationData] = useState(null)
  const [remunerationPoliciesData, setRemunerationPoliciesData] = useState(null)
  const [determineRemunerationData, setDetermineRemunerationData] = useState(null)
  const [annualTotalCompensationData, setAnnualTotalCompensationData] = useState(null)
  const [developmentStrategyData, setDevelopmentStrategyData] = useState(null)
  const [policyCommitmentsData, setPolicyCommitmentsData] = useState(null)
  const [embeddingPolicyCommitmentsData, setEmbeddingPolicyCommitmentsData] = useState(null)
  const [processToRemediateData, setProcessToRemediateData] = useState(null)
  const [mechanismForSeekingAdviceData, setMechanismForSeekingAdviceData] = useState(null)
  const [complianceWithLawsData, setComplianceWithLawsData] = useState(null)
  const [membershipAssociationsData, setMembershipAssociationsData] = useState(null)
  const [stakeholderEngagementApproachData, setStakeholderEngagementApproachData] = useState(null)
  const [stackHolderEngagementData, setStackHolderEngagementData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchData()
  }, [id])

  const fetchData = async () => {
    try {
      setLoading(true)
      const res = await get(`/gri/get?Id=${id}&type=GeneralDisclosures2021`)
      const sustainabilityReport = res?.data?.data?.GeneralDisclosures2021?.orgSustainabilityReport
      const reportingPeriod = res?.data?.data?.GeneralDisclosures2021?.reportingPeriod
      const restatements = res?.data?.data?.GeneralDisclosures2021?.restatementsExplanation
      const externalAssurance = res?.data?.data?.GeneralDisclosures2021?.extenalAssurance
      const activitiesValueChain = res?.data?.data?.GeneralDisclosures2021?.activitiesValueChainBusinessRelationships
      const employees = res?.data?.data?.GeneralDisclosures2021?.employees
      const nonEmployeeWorkers = res?.data?.data?.GeneralDisclosures2021?.nonEmployeeWorkers
      const governanceStructure = res?.data?.data?.GeneralDisclosures2021?.governanceStructureComposition
      const nominationSelection = res?.data?.data?.GeneralDisclosures2021?.nominationSelectionProcesses
      const chairExecPosition = res?.data?.data?.GeneralDisclosures2021?.chairExecPosition
      const governanceBodyRoleInStrategy = res?.data?.data?.GeneralDisclosures2021?.governanceBodyRoleInStrategy
      const delegation = res?.data?.data?.GeneralDisclosures2021?.delegation
      const governanceBodyRole = res?.data?.data?.GeneralDisclosures2021?.governanceBodyRole
      const conflictsOfInterest = res?.data?.data?.GeneralDisclosures2021?.conflictsOfInterest
      const criticalConcerns = res?.data?.data?.GeneralDisclosures2021?.criticalConcernsCommunicationProcess
      const measuresToEnhanceKnowledge = res?.data?.data?.GeneralDisclosures2021?.measuresToEnhanceGovernanceBodyKnowledge
      const performanceEvaluation = res?.data?.data?.GeneralDisclosures2021?.performanceEvaluationProcess
      const remunerationPolicies = res?.data?.data?.GeneralDisclosures2021?.remunerationPolicies
      const determineRemuneration = res?.data?.data?.GeneralDisclosures2021?.determineRemuneration
      const annualTotalCompensation = res?.data?.data?.GeneralDisclosures2021?.annulTotalCompensation
      const developmentStrategy = res?.data?.data?.GeneralDisclosures2021?.devlopmentStrategy
      const policyCommitments = res?.data?.data?.GeneralDisclosures2021?.policyCommitments
      const embeddingPolicyCommitments = res?.data?.data?.GeneralDisclosures2021?.emeddingPolicyCommitments
      const processToRemediate = res?.data?.data?.GeneralDisclosures2021?.processToRemediate
      const mechanismForSeekingAdvice = res?.data?.data?.GeneralDisclosures2021?.mechanismForSeekingAdvice
      const complianceWithLaws = res?.data?.data?.GeneralDisclosures2021?.compinaceWithLaws
      const membershipAssociations = res?.data?.data?.GeneralDisclosures2021?.membershipAssociations
      const stakeholderEngagementApproach = res?.data?.data?.GeneralDisclosures2021?.stakeholderEngagementApproach
      const stackHolderEngagement = res?.data?.data?.GeneralDisclosures2021?.stackHolderEngagement
      
      setData(sustainabilityReport)
      setReportingPeriodData(reportingPeriod)
      setRestatementsData(restatements)
      setExternalAssuranceData(externalAssurance)
      setActivitiesValueChainData(activitiesValueChain)
      setEmployeesData(employees)
      setNonEmployeeWorkersData(nonEmployeeWorkers)
      setGovernanceStructureData(governanceStructure)
      setNominationSelectionData(nominationSelection)
      setChairExecPositionData(chairExecPosition)
      setGovernanceBodyRoleInStrategyData(governanceBodyRoleInStrategy)
      setDelegationData(delegation)
      setGovernanceBodyRoleData(governanceBodyRole)
      setConflictsOfInterestData(conflictsOfInterest)
      setCriticalConcernsData(criticalConcerns)
      setMeasuresToEnhanceKnowledgeData(measuresToEnhanceKnowledge)
      setPerformanceEvaluationData(performanceEvaluation)
      setRemunerationPoliciesData(remunerationPolicies)
      setDetermineRemunerationData(determineRemuneration)
      setAnnualTotalCompensationData(annualTotalCompensation)
      setDevelopmentStrategyData(developmentStrategy)
      setPolicyCommitmentsData(policyCommitments)
      setEmbeddingPolicyCommitmentsData(embeddingPolicyCommitments)
      setProcessToRemediateData(processToRemediate)
      setMechanismForSeekingAdviceData(mechanismForSeekingAdvice)
      setComplianceWithLawsData(complianceWithLaws)
      setMembershipAssociationsData(membershipAssociations)
      setStakeholderEngagementApproachData(stakeholderEngagementApproach)
      setStackHolderEngagementData(stackHolderEngagement)
    } catch (err) {
      console.log('Error fetching GRI data:', err)
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return (
      <div className={styles.loadingContainer}>
        <p>Loading...</p>
      </div>
    )
  }

  // Prepare entity table data
  const entityColumns = [
    { field: 'entityName', label: 'Entity Name', width: 'auto' }
  ]

  const entityRows = data?.listOfAllEntities || []

  // Prepare audit table data
  const auditColumns = [
    { field: 'entityName', label: 'Entity Name', width: '30%' },
    { field: 'distance', label: 'Reason For Distance', width: '70%' }
  ]

  const auditRows = data?.auditedConsolidatedFinancialStatement || []

  // Consolidating information data
  const consolidatingInfo = data?.consolidatingInformations || {}

  // Reporting period data
  const sustainabilityReporting = reportingPeriodData?.sustainabilityReportingPeriod || {}
  const financialReporting = reportingPeriodData?.financialSustainabilityReportingPeriodDifference || {}
  const publicationDate = reportingPeriodData?.sustainabilityReportPublicationDate || ''
  const contactInfo = reportingPeriodData?.sustainabilityReportContact || {}

  // Prepare restatements table data
  const restatementsColumns = [
    { field: 'reportingPeriod', label: 'Reporting Period', width: '20%' },
    { field: 'reasonForRestatement', label: 'Reason for Restatements', width: '35%' },
    { field: 'effectOfRestatement', label: 'Effects of Restatements', width: '35%' }
  ]

  const restatementsRows = Array.isArray(restatementsData) ? restatementsData : []

  // External assurance data
  const policyAndProcedure = externalAssuranceData?.policyAndProcedure || ''
  const underGoneAssurance = externalAssuranceData?.underGoneAssurance || {}

  // Activities, value chain and business relationships data
  const operatingSectors = activitiesValueChainData?.operatingSectors || []
  const valueChainActivities = activitiesValueChainData?.valueChainEntitiesActivities || {}
  const businessRelationships = activitiesValueChainData?.businessRelationshipsSustainabilityPerformance || ''
  const industrySectorChanges = activitiesValueChainData?.industrySectorChangeBusinessRelationships || ''

  // Format operating sectors - handle both array and string formats
  const formatOperatingSectors = () => {
    if (!operatingSectors || operatingSectors.length === 0) return '-'
    if (Array.isArray(operatingSectors)) {
      return operatingSectors.map(sector => typeof sector === 'string' ? sector : sector.name).join(', ')
    }
    return operatingSectors
  }

  // Employees data
  const organizationBreakDown = employeesData?.organizationBreakDown || []
  const reportNumber = employeesData?.reportNumber || {}
  const dataCompilationMethodology = employeesData?.dataCompilationMethodology || {}
  const employeeDataContextualInfo = employeesData?.employeeDataContextualInfo || ''
  const employeeFluctuations = employeesData?.employeeFluctuations || ''

  // Employee table columns
  const employeeColumns = [
    { field: 'region', label: 'Region', width: '20%' },
    { field: 'maleEmployees', label: 'Male', width: '15%' },
    { field: 'femaleEmployees', label: 'Female', width: '15%' },
    { field: 'other', label: 'Other', width: '15%' },
    { field: 'notDisclosed', label: 'Not Disclosed', width: '15%' },
    { field: 'totalEmployees', label: 'Total No. of Employees', width: '20%' }
  ]

  const permanentEmployeeColumns = [
    { field: 'region', label: 'Region', width: '20%' },
    { field: 'maleEmployees', label: 'Male', width: '15%' },
    { field: 'femaleEmployees', label: 'Female', width: '15%' },
    { field: 'other', label: 'Other', width: '15%' },
    { field: 'notDisclosed', label: 'Not Disclosed', width: '15%' },
    { field: 'totalEmployees', label: 'Total No. of Permanent Employees', width: '20%' }
  ]

  const temporaryEmployeeColumns = [
    { field: 'region', label: 'Region', width: '20%' },
    { field: 'maleEmployees', label: 'Male', width: '15%' },
    { field: 'femaleEmployees', label: 'Female', width: '15%' },
    { field: 'other', label: 'Other', width: '15%' },
    { field: 'notDisclosed', label: 'Not Disclosed', width: '15%' },
    { field: 'totalEmployees', label: 'Total No. of Temporary Employees', width: '20%' }
  ]

  const nonGuaranteedHoursColumns = [
    { field: 'region', label: 'Region', width: '20%' },
    { field: 'maleEmployees', label: 'Male', width: '15%' },
    { field: 'femaleEmployees', label: 'Female', width: '15%' },
    { field: 'other', label: 'Other', width: '15%' },
    { field: 'notDisclosed', label: 'Not Disclosed', width: '15%' },
    { field: 'totalEmployees', label: 'Total Number of non-guaranteed hours Employees', width: '20%' }
  ]

  const fullTimeEmployeeColumns = [
    { field: 'region', label: 'Region', width: '20%' },
    { field: 'maleEmployees', label: 'Male', width: '15%' },
    { field: 'femaleEmployees', label: 'Female', width: '15%' },
    { field: 'other', label: 'Other', width: '15%' },
    { field: 'notDisclosed', label: 'Not Disclosed', width: '15%' },
    { field: 'totalEmployees', label: 'Total Number of Full-time Employees', width: '20%' }
  ]

  const partTimeEmployeeColumns = [
    { field: 'region', label: 'Region', width: '20%' },
    { field: 'maleEmployees', label: 'Male', width: '15%' },
    { field: 'femaleEmployees', label: 'Female', width: '15%' },
    { field: 'other', label: 'Other', width: '15%' },
    { field: 'notDisclosed', label: 'Not Disclosed', width: '15%' },
    { field: 'totalEmployees', label: 'Total Number of Part-time Employees', width: '20%' }
  ]

  // Employee table rows
  const organizationBreakDownRows = Array.isArray(organizationBreakDown) ? organizationBreakDown : []
  const permanentEmployeeRows = Array.isArray(reportNumber?.permanentEmployee) ? reportNumber.permanentEmployee : []
  const temporaryEmployeeRows = Array.isArray(reportNumber?.temporaryEmployee) ? reportNumber.temporaryEmployee : []
  const nonGuaranteedHoursRows = Array.isArray(reportNumber?.nonGuaranteedHours) ? reportNumber.nonGuaranteedHours : []
  const fullTimeEmployeeRows = Array.isArray(reportNumber?.fullTimeEmployee) ? reportNumber.fullTimeEmployee : []
  const partTimeEmployeeRows = Array.isArray(reportNumber?.partTimeEmployees) ? reportNumber.partTimeEmployees : []

  // Non-employee workers data
  const employeeWorkersTotal = nonEmployeeWorkersData?.employeeWorkersTotal || {}
  const methodologiesAndAssumptions = nonEmployeeWorkersData?.methodologiesAndAssumptions || {}
  const employeeWorkerFluctuations = nonEmployeeWorkersData?.employeeWorkerFluctuations || ''

  // Governance structure and composition data
  const structureCommittees = governanceStructureData?.structureCommittees || ''
  const listOfCommittes = governanceStructureData?.listOfCommittes || ''
  const bodyComposition = governanceStructureData?.bodyComposition || ''

  // Nomination and selection data
  const selectionCriteria = nominationSelectionData?.selectionCriteria || ''
  const nominatingAndSelecting = nominationSelectionData?.nominatingAndSelecting || ''

  // Chair executive position data
  const nonExecPosition = chairExecPositionData?.nonExecPosition || ''
  const excutiveRole = chairExecPositionData?.excutiveRole || ''

  // Governance body role in strategy data
  const stakeholderEngagement = governanceBodyRoleInStrategyData?.stakeholderEngagement || ''
  const stakeholderFeedbackInDecisionMaking = governanceBodyRoleInStrategyData?.stakeholderFeedbackInDecisionMaking || {}
  const governanceBodyEffectivenessReview = governanceBodyRoleInStrategyData?.governanceBodyEffectivenessReview || ''

  // Delegation data
  const governanceBodyDelegationOfResponsibility = delegationData?.governanceBodyDelegationOfResponsibility || {}
  const reportingToGovernanceBodyFrequency = delegationData?.reportingToGovernanceBodyFrequency || ''

  // Governance body role data
  const approvalProcess = governanceBodyRoleData?.approvalProcess || ''
  const responsibilityForSustainabilityInfo = governanceBodyRoleData?.responsibilityForSustainabilityInfo || ''

  // Conflicts of interest data
  const interestPrevention = conflictsOfInterestData?.interestPrevention || ''
  const stakeholderConflictDisclosure = conflictsOfInterestData?.stakeholderConflictDisclosure || {}

  // Critical concerns data
  const criticalConcernsReported = criticalConcernsData?.criticalConcernsReported || ''
  const criticalConcernsSummary = criticalConcernsData?.criticalConcernsSummary || ''

  // Measures to enhance knowledge data
  const measuresToEnhanceGovernanceBodyKnowledge = measuresToEnhanceKnowledgeData || ''

  // Performance evaluation data
  const devlopmentTopics = performanceEvaluationData?.devlopmentTopics || ''
  const independentEvaluationBody = performanceEvaluationData?.independentEvaluationBody || ''
  const actionsTakenInResponseToEvaluations = performanceEvaluationData?.actionsTakenInResponseToEvaluations || ''

  // Remuneration policies data
  const performanceRelatedRemuneration = remunerationPoliciesData?.performanceRelatedRemuneration || ''
  const incentivesAndBenefits = remunerationPoliciesData?.incentivesAndBenefits || ''

  // Determine remuneration data
  const remunerationPolicyDesign = determineRemunerationData?.remunerationPolicyDesign || {}
  const remunerationVoteResults = determineRemunerationData?.remunerationVoteResults || ''

  // Annual total compensation data
  const medianEmployeeCompensationRatio = annualTotalCompensationData?.medianEmployeeCompensationRatio || {}
  const highestPaidCompensationIncreaseRatio = annualTotalCompensationData?.highestPaidCompensationIncreaseRatio || {}
  const payRatioCalculationMethodology = annualTotalCompensationData?.payRatioCalculationMethodology || ''
  const additionalContextualInformation = annualTotalCompensationData?.additionalContextualInformation || ''

  // Development strategy data
  const devlopmentStrategy = developmentStrategyData || ''

  // Policy commitments data
  const responsibleBusinessConductCommitments = policyCommitmentsData?.responsibleBusinessConductCommitments || {}
  const specificHumanRightsPolicy = policyCommitmentsData?.specificHumanRightsPolicy || {}
  const policyCommitmentLinks = policyCommitmentsData?.policyCommitmentLinks || ''
  const approvalLevelHumanRightsCommitment = policyCommitmentsData?.approvalLevelHumanRightsCommitment || ''
  const policyCommitmentScope = policyCommitmentsData?.policyCommitmentScope || ''
  const policyCommitmentCommunication = policyCommitmentsData?.policyCommitmentCommunication || ''

  // Embedding policy commitments data
  const responsibilityAllocation = embeddingPolicyCommitmentsData?.responsibilityAllocation || {}

  // Process to remediate data
  const remediationCommitments = processToRemediateData?.remediationCommitments || ''
  const grievanceMechanisms = processToRemediateData?.grievanceMechanisms || ''
  const remediationProcesses = processToRemediateData?.remediationProcesses || ''
  const stakeholderInvolvementGrievance = processToRemediateData?.stakeholderInvolvementGrievance || ''
  const grievanceMechanismEffectiveness = processToRemediateData?.grievanceMechanismEffectiveness || ''

  // Mechanism for seeking advice data
  const adviceMechanisms = mechanismForSeekingAdviceData?.adviceMechanisms || ''
  const concernRaisingMechanisms = mechanismForSeekingAdviceData?.concernRaisingMechanisms || ''

  // Compliance with laws data
  const totalNonComplianceInstances = complianceWithLawsData?.totalNonComplianceInstances || {}
  const numberOfFines = complianceWithLawsData?.numberOfFines || {}
  const monetoryValue = complianceWithLawsData?.monetoryValue || {}
  const significantNonComplianceInstances = complianceWithLawsData?.significantNonComplianceInstances || ''
  const nonComplianceSeverityAssessment = complianceWithLawsData?.nonComplianceSeverityAssessment || ''

  // Membership associations data
  const membershipAssociations = membershipAssociationsData || ''

  // Stakeholder engagement approach data
  const stakeholderOrg = stakeholderEngagementApproachData?.stakeholderOrg || {}
  const approachengaging = stakeholderOrg?.approachengaging || ''
  const specifyMethodlogyUse = stakeholderOrg?.specifyMethodlogyUse || ''
  const stakeholderEngagementPurposes = stakeholderOrg?.stakeholderEngagementPurposes || ''
  const meaningfulStakeholderEngagement = stakeholderOrg?.meaningfulStakeholderEngagement || ''

  // Stack holder engagement data
  const collectiveBargainingAgreements = stackHolderEngagementData?.collectiveBargainingAgreements || {}
  const referencedAgreementsTypes = stackHolderEngagementData?.referencedAgreementsTypes || ''

  // Prepare collective bargaining table data
  const collectiveBargainingColumns = [
    { field: 'totalEmployees', label: 'Total number of employees', width: '33%' },
    { field: 'employeesUnderBargaining', label: 'Number of employees under collective bargaining', width: '34%' },
    { field: 'percentage', label: 'Percentage', width: '33%' }
  ]

  const collectiveBargainingRows = collectiveBargainingAgreements?.total || collectiveBargainingAgreements?.numberOfEmployees || collectiveBargainingAgreements?.percentage
    ? [{
        totalEmployees: collectiveBargainingAgreements?.total || '-',
        employeesUnderBargaining: collectiveBargainingAgreements?.numberOfEmployees || '-',
        percentage: collectiveBargainingAgreements?.percentage ? `${collectiveBargainingAgreements.percentage}%` : '-'
      }]
    : []

  // Prepare annual total compensation ratio table data (section a)
  const annualCompensationRatioColumns = [
    { field: 'highestPaidCompensation', label: "Highest-paid individual's annual compensation", width: '33%' },
    { field: 'medianCompensation', label: 'Median annual total compensation for all employees, excluding the highest earner', width: '34%' },
    { field: 'ratio', label: 'Ratio', width: '33%' }
  ]

  const annualCompensationRatioRows = highestPaidCompensationIncreaseRatio?.topExecutive || highestPaidCompensationIncreaseRatio?.mediumPercentage || highestPaidCompensationIncreaseRatio?.ration
    ? [{
        highestPaidCompensation: highestPaidCompensationIncreaseRatio?.topExecutive || '-',
        medianCompensation: highestPaidCompensationIncreaseRatio?.mediumPercentage || '-',
        ratio: highestPaidCompensationIncreaseRatio?.ration || '-'
      }]
    : []

  // Prepare percentage increase ratio table data (section b)
  const percentageIncreaseRatioColumns = [
    { field: 'topExecutiveIncrease', label: 'Percentage increase in top executive compensation', width: '33%' },
    { field: 'medianIncrease', label: 'Median percentage increase in annual total compensation for all employees, excluding the highest earner', width: '34%' },
    { field: 'ratio', label: 'Ratio', width: '33%' }
  ]

  const percentageIncreaseRatioRows = medianEmployeeCompensationRatio?.annual || medianEmployeeCompensationRatio?.allEmployees || medianEmployeeCompensationRatio?.ration
    ? [{
        topExecutiveIncrease: medianEmployeeCompensationRatio?.annual || '-',
        medianIncrease: medianEmployeeCompensationRatio?.allEmployees || '-',
        ratio: medianEmployeeCompensationRatio?.ration || '-'
      }]
    : []

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return '-'
    try {
      const date = new Date(dateString)
      const day = String(date.getDate()).padStart(2, '0')
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const year = date.getFullYear()
      return `${day}/${month}/${year}`
    } catch (e) {
      return dateString
    }
  }

  // Format phone number with country code
  const formatPhone = () => {
    const countryCode = contactInfo?.countryCode || ''
    const phone = contactInfo?.phone || ''
    if (!phone) return '-'
    return countryCode ? `${countryCode}${phone}` : phone
  }

  return (
    <>
      {/* Section 2-2 */}
      <div className={styles.container}>
      {/* Main Heading */}
        <h1 className={styles.mainHeading}>
        2-2 ENTITIES INCLUDED IN THE ORGANIZATION'S SUSTAINABILITY REPORTING
        </h1>

      {/* Sub-section a: List of all entities */}
      <ReportTable
        title="a. Provide a list of all entities included in your organization's sustainability reporting"
        columns={entityColumns}
        rows={entityRows}
        showSerialNumber={true}
      />

      {/* Sub-section b: Audited consolidated financial statements */}
      <ReportTable
        title="b. If your organization has audited consolidated financial statements or financial information filled on public record, specify any differences between the list of entities included in your financial reporting and those included in your sustainability reporting."
        columns={auditColumns}
        rows={auditRows}
        showSerialNumber={true}
      />

      {/* Sub-section c: Consolidating information */}
      <div className={styles.consolidatingSection}>
        <p className={`${`${styles.consolidatingTitle} common_text_style`}`}>
          c. When consolidating information for multiple entities, explain the approach used, including:
        </p>

        <div className={styles.questionsContainer}>
          {/* Question i */}
          <div className={styles.questionBox}>
            <p className={`${styles.questionTitle} common_text_style`}>
              i. Does the approach involve adjustments to information for minority interests?
            </p>
            <p className={styles.questionAnswer}>
              {consolidatingInfo?.minorityInterest || '-'}
            </p>
          </div>

          {/* Question ii */}
          <div className={styles.questionBox}>
            <p className={`${styles.questionTitle} common_text_style`}>
              ii. How does the approach consider mergers, acquisitions, and disposal of entities or parts of entities?
            </p>
            <p className={styles.questionAnswer}>
              {consolidatingInfo?.disposalOfEntity || '-'}
            </p>
          </div>

          {/* Question iii */}
          <div className={styles.questionBox}>
            <p className={`${styles.questionTitle} common_text_style`}>
              iii. Does the approach differ across the disclosures in this Standard and across material topics?
            </p>
            <p className={styles.questionAnswer}>
              {consolidatingInfo?.matrialTopics || '-'}
            </p>
          </div>
        </div>
      </div>
      </div>

      {/* Section 2-3 */}
      <div className={styles.container}>
        {/* Main Heading */}
        <h1 className={styles.mainHeading}>
          2-3 REPORTING PERIOD, FREQUENCY AND CONTACT POINT
        </h1>

        {/* Sub-section a: Sustainability reporting period */}
        <div className={styles.consolidatingSection}>
          <p className={`${`${styles.consolidatingTitle} common_text_style`} common_text_style`}>
            a. What is the reporting period for your sustainability reporting, and how often is it conducted?
          </p>
          <div className={`${styles.questionsContainer} ${styles.sameLineGroup}`}>
            <div className={styles.questionBox}>
              <div className={styles.questionRow}>
                <span className={styles.questionValue}>
                  Reporting period:
                </span>
                <span className={`${styles.questionLabel} common_text_style`}>
                  {sustainabilityReporting?.reportingPeriod || '-'}
                </span>
              </div>
            </div>
            <div className={styles.questionBox}>
              <div className={styles.questionRow}>
                <span className={styles.questionValue}>
                  Frequency of reporting:
                </span>
                <span className={`${styles.questionLabel} common_text_style`}>
                  {sustainabilityReporting?.frequencyReported || '-'}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Sub-section b: Financial reporting period */}
        <div className={styles.consolidatingSection}>
          <p className={`${`${styles.consolidatingTitle} common_text_style`} common_text_style`}>
            b. What is the reporting period for your financial reporting, and if it differs from your sustainability reporting period, please explain the reason for this discrepancy?
          </p>
          <div className={`${styles.questionsContainer} ${styles.sameLineGroup}`}>
            <div className={styles.questionBox}>
              <div className={styles.questionRow}>
                <span className={styles.questionValue}>
                  Reporting period:
                </span>
                <span className={`${styles.questionLabel} common_text_style`}>
                  {financialReporting?.reportingPeriod || '-'}
                </span>
              </div>
            </div>
            <div className={styles.questionBox}>
              <div className={styles.questionRow}>
                <span className={styles.questionValue}>
                  Reason for Discrepancy:
                </span>
                <span className={`${styles.questionLabel} common_text_style`}>
                  {financialReporting?.discrepancy || '-'}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Sub-section c: Publication date */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            c. When was your sustainability report or reported information published?
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <div className={styles.questionRow}>
                <span className={styles.questionValue}>
                  Date:
                </span>
                <span className={`${styles.questionLabel} common_text_style`}>
                  {formatDate(publicationDate)}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Sub-section d: Contact information */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            d. Who should be contacted for inquiries regarding your sustainability report or reported information?
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <div className={styles.questionRow}>
                <span className={styles.questionValue}>
                  Full Name:
                </span>
                <span className={`${styles.questionLabel} common_text_style`}>
                  {contactInfo?.name || '-'}
                </span>
              </div>
            </div>
            <div className={styles.questionBox}>
              <div className={styles.questionRow}>
                <span className={styles.questionValue}>
                  Designation:
                </span>
                <span className={`${styles.questionLabel} common_text_style`}>
                  {contactInfo?.designation || '-'}
                </span>
              </div>
            </div>
            <div className={styles.questionBox}>
              <div className={styles.questionRow}>
                <span className={styles.questionValue}>
                  Phone Number:
                </span>
                <span className={`${styles.questionLabel} common_text_style`}>
                  {formatPhone()}
                </span>
              </div>
            </div>
            <div className={styles.questionBox}>
              <div className={styles.questionRow}>
                <span className={styles.questionValue}>
                  Email ID:
                </span>
                <span className={`${styles.questionLabel} common_text_style`}>
                  {contactInfo?.email || '-'}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2-4 */}
      <div className={styles.container}>
        {/* Main Heading */}
        <h1 className={styles.mainHeading}>
          2-4 RESTATEMENTS OF INFORMATION
        </h1>

        {/* Sub-section a: Restatements table */}
        <ReportTable
          title="a. Report restatements of information made from previous reporting periods:"
          columns={restatementsColumns}
          rows={restatementsRows}
          showSerialNumber={true}
        />
      </div>

      {/* Section 2-5 */}
      <div className={styles.container}>
        {/* Main Heading */}
        <h1 className={styles.mainHeading}>
          2-5 EXTERNAL ASSURANCE
        </h1>

        {/* Sub-section a: Policy and procedure */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            a. Describe the organization's policy and procedure for seeking external assurance, including details on the involvement of the highest governance body and senior executives.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {policyAndProcedure || '-'}
              </p>
            </div>
          </div>
        </div>

        {/* Sub-section b: If undergone external assurance */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            b. If the organization's sustainability reporting has undergone external assurance:
          </p>

          <div className={styles.questionsContainer}>
            {/* Question i */}
            <div className={styles.questionBox}>
              <p className={styles.questionTitle}>
                i. Provide a link or reference to the external assurance report(s) or assurance statement(s).
              </p>
              <p className={styles.questionAnswer}>
                {underGoneAssurance?.assuranceStatement || '-'}
              </p>
            </div>

            {/* Question ii */}
            <div className={styles.questionBox}>
              <p className={styles.questionTitle}>
                ii. Describe the scope of information and processes covered, the responsibilities of the organization in relation to the assurance provider, the assurance standards used, the level of assurance obtained, any limitations of the assurance process, and a summary of the conclusions reached by the assurance provider.
              </p>
              <p className={styles.questionAnswer}>
                {underGoneAssurance?.assuranceProvider || '-'}
              </p>
            </div>

            {/* Question iii */}
            <div className={styles.questionBox}>
              <p className={styles.questionTitle}>
                iii. Describe the relationship between the organization and the assurance provider, including details on the independence of the assurance provider, their experience, qualifications, and expertise.
              </p>
              <p className={styles.questionAnswer}>
                {underGoneAssurance?.qualificationAndExpertise || '-'}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2-6 */}
      <div className={styles.container}>
        {/* Main Heading */}
        <h1 className={styles.mainHeading}>
          2-6 ACTIVITIES, VALUE CHAIN AND OTHER BUSINESS RELATIONSHIPS
        </h1>

        {/* Sub-section a: Operating sectors */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            a. Report the sectors in which organization is operating or active.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {formatOperatingSectors()}
              </p>
            </div>
          </div>
        </div>

        {/* Sub-section b: Value chain */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            b. Describe organization's value chain including entities upstreams and downstreams activities.
          </p>

          <div className={styles.questionsContainer}>
            {/* Question i */}
            <div className={styles.questionBox}>
              <p className={styles.questionTitle}>
                i. Describe the organization's core activities, the products or services it offer, and the markets it serve.
              </p>
              <p className={styles.questionAnswer}>
                {valueChainActivities?.coreActivitiesProductsServicesMarkets || '-'}
              </p>
            </div>

            {/* Question ii */}
            <div className={styles.questionBox}>
              <p className={styles.questionTitle}>
                ii. Describe the organization's supply chain consider providing details on supplier types, sector characteristics, monetary value, geographic location, suppliers activities, business relationships etc.
              </p>
              <p className={styles.questionAnswer}>
                {valueChainActivities?.supplyChainDetails || '-'}
              </p>
            </div>

            {/* Question iii */}
            <div className={styles.questionBox}>
              <p className={styles.questionTitle}>
                iii. Describe the entities downstream from organization and it's activities related to organization's offerings.
              </p>
              <p className={styles.questionAnswer}>
                {valueChainActivities?.downstreamEntitiesActivities || '-'}
              </p>
            </div>
          </div>
        </div>

        {/* Sub-section c: Business relationships */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            c. Describe organization's other significant business relationships beyond its immediate suppliers and customers that are relevant to organization's sustainability performance.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {businessRelationships || '-'}
              </p>
            </div>
          </div>
        </div>

        {/* Sub-section d: Industry sector changes */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            d. Describe any significant changes in organization's industry sector(s), value chain, or other relevant business relationships compared to the previous reporting period.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {industrySectorChanges || '-'}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2-7 */}
      <div className={styles.container}>
        {/* Main Heading */}
        <h1 className={styles.mainHeading}>
          2-7 EMPLOYEES
        </h1>

        {/* Sub-section a: Total employees breakdown */}
        <ReportTable
          title="a. Provide the total number of employees in the organization, and a breakdown of this total by gender and by region."
          columns={employeeColumns}
          rows={organizationBreakDownRows}
          showSerialNumber={true}
        />

        {/* Sub-section b: Number of employees by type */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            b. Report the number of:
          </p>

          <div className={styles.questionsContainer}>
            {/* Permanent employees */}
            <div className={styles.questionBox}>
              <ReportTable
                title="i. Provide the total number of permanent employees in the organization, and a breakdown of this total by gender and by region."
                columns={permanentEmployeeColumns}
                rows={permanentEmployeeRows}
                showSerialNumber={true}
              />
            </div>

            {/* Temporary employees */}
            <div className={styles.questionBox}>
              <ReportTable
                title="ii. Provide the total number of temporary employees in the organization, and a breakdown of this total by gender and by region."
                columns={temporaryEmployeeColumns}
                rows={temporaryEmployeeRows}
                showSerialNumber={true}
              />
            </div>

            {/* Non-guaranteed hours employees */}
            <div className={styles.questionBox}>
              <ReportTable
                title="iii. Provide the total number of non-guaranteed hours employees in the organization, and a breakdown of this total by gender and by region."
                columns={nonGuaranteedHoursColumns}
                rows={nonGuaranteedHoursRows}
                showSerialNumber={true}
              />
            </div>

            {/* Full-time employees */}
            <div className={styles.questionBox}>
              <ReportTable
                title="iv. Provide the total number of full-time employees in the organization, and a breakdown of this total by gender and by region."
                columns={fullTimeEmployeeColumns}
                rows={fullTimeEmployeeRows}
                showSerialNumber={true}
              />
            </div>

            {/* Part-time employees */}
            <div className={styles.questionBox}>
              <ReportTable
                title="v. Provide the total number of part-time employees in the organization, and a breakdown of this total by gender and by region."
                columns={partTimeEmployeeColumns}
                rows={partTimeEmployeeRows}
                showSerialNumber={true}
              />
            </div>
          </div>
        </div>

        {/* Sub-section c: Data compilation methodology */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            c. Describe the methodologies and assumptions used to compile the data, including whether the numbers are reported.
          </p>

          <div className={styles.questionsContainer}>
            {/* Question i */}
            <div className={styles.questionBox}>
              <p className={styles.questionTitle}>
                i. Describe if the employee figures reported in headcount (total number of employees) or Full-Time Equivalent (FTE).
              </p>
              <p className={styles.questionAnswer}>
                {dataCompilationMethodology?.employeeFiguresReporting || '-'}
              </p>
            </div>

            {/* Question ii */}
            <div className={styles.questionBox}>
              <p className={styles.questionTitle}>
                ii. Describe if the data represent the number of employees at the end of the reporting period, the average number of employees throughout the period, or another timeframe?
              </p>
              <p className={styles.questionAnswer}>
                {dataCompilationMethodology?.employeeDataTimeframe || '-'}
              </p>
            </div>
          </div>
        </div>

        {/* Sub-section d: Contextual information */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            d. Describe if there's contextual information necessary to understand the data reported under total number of employees and employees by gender breakdown.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {employeeDataContextualInfo || '-'}
              </p>
            </div>
          </div>
        </div>

        {/* Sub-section e: Employee fluctuations */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            e. Describe the significant fluctuations in the number of employees during the reporting period and between reporting periods within the organization.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {employeeFluctuations || '-'}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2-8 */}
      <div className={styles.container}>
        {/* Main Heading */}
        <h1 className={styles.mainHeading}>
          2-8 WORKERS WHO ARE NOT EMPLOYEES
        </h1>

        {/* Sub-section a: Total number of non-employee workers */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            a. Provide the total number of workers who are not employees and whose work is controlled by the organization.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {employeeWorkersTotal?.controllerByOrganization || '-'}
              </p>
            </div>

            {/* Question i */}
            <div className={styles.questionBox}>
              <p className={styles.questionTitle}>
                i. Briefly describe the most common type of non-employee worker e.g. independent contractors, consultants, freelancers etc. and explain how the organization contracts with these workers (e.g., written contracts, service agreements)
              </p>
              <p className={styles.questionAnswer}>
                {employeeWorkersTotal?.commonTypeEmployees || '-'}
              </p>
            </div>

            {/* Question ii */}
            <div className={styles.questionBox}>
              <p className={styles.questionTitle}>
                ii. Briefly describe the types of work these non-employee workers perform for the organization.
              </p>
              <p className={styles.questionAnswer}>
                {employeeWorkersTotal?.performForOrganization || '-'}
              </p>
            </div>
          </div>
        </div>

        {/* Sub-section b: Methodologies and assumptions */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            b. Describe the methodologies and assumptions used by the organization to identify workers who are not employees but whose work is controlled by the organization through contracts, project assignments etc
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {methodologiesAndAssumptions?.projectAssignments || '-'}
              </p>
            </div>

            {/* Question i */}
            <div className={styles.questionBox}>
              <p className={styles.questionTitle}>
                i. If FTE is used for reporting non-employee workers in headcount (total number of individuals) or Full-Time Equivalent (FTE), explain the methodology for calculating FTE from non-employee workers.
              </p>
              <p className={styles.questionAnswer}>
                {methodologiesAndAssumptions?.FTEReporting || '-'}
              </p>
            </div>

            {/* Question ii */}
            <div className={styles.questionBox}>
              <p className={styles.questionTitle}>
                ii. Describe if the data represent the number of non-employee workers at the end of the reporting period, the average number of employees throughout the period, or another timeframe?
              </p>
              <p className={styles.questionAnswer}>
                {methodologiesAndAssumptions?.anotherTimeFrame || '-'}
              </p>
            </div>
          </div>
        </div>

        {/* Sub-section c: Fluctuations */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            c. Describe the significant fluctuations in the number of non-employee workers during the reporting period and between reporting periods within the organization.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {employeeWorkerFluctuations || '-'}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2-9 */}
      <div className={styles.container}>
        {/* Main Heading */}
        <h1 className={styles.mainHeading}>
          2-9 GOVERNANCE STRUCTURE AND COMPOSITION
        </h1>

        {/* Sub-section a: Governance structure */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            a. Describe the organization's governance structure, including committees of the highest governance body.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {structureCommittees || '-'}
              </p>
            </div>
          </div>
        </div>

        {/* Sub-section b: List of committees */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            b. Provide a list of the committees within the highest governance body responsible for making decisions and overseeing the organization's impact on the economy, environment, and people.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {listOfCommittes || '-'}
              </p>
            </div>
          </div>
        </div>

        {/* Sub-section c: Body composition */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            c. Describe the composition of the highest governance body and its committees by executive and non-executive members, independence, tenure of members on the governance body, number of other significant positions and commitments held by each member, and the nature of the commitments, gender, under-represented social groups, competencies relevant to the impacts of the organization, stakeholder representation.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {bodyComposition || '-'}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2-10 */}
      <div className={styles.container}>
        {/* Main Heading */}
        <h1 className={styles.mainHeading}>
          2-10 NOMINATION AND SELECTION OF THE HIGHEST GOVERNANCE BODY
        </h1>

        {/* Sub-section a: Nomination and selection processes */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            a. Describe the nomination and selection processes for the highest governance body and its committees in the organisation.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {selectionCriteria || '-'}
              </p>
            </div>
          </div>
        </div>

        {/* Sub-section b: Criteria for nominating and selecting */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            b. Describe the criteria used for nominating and selecting highest governance body members, including whether and how the views of stakeholders (including shareholders), diversity, independence; competencies relevant to the impacts of the organization are taken into consideration.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {nominatingAndSelecting || '-'}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2-11 */}
      <div className={styles.container}>
        {/* Main Heading */}
        <h1 className={styles.mainHeading}>
          2-11 CHAIR OF THE HIGHEST GOVERNANCE BODY
        </h1>

        {/* Sub-section a */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            a. Does the chair of the highest governance body also hold a senior executive position within the organization?
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {nonExecPosition || '-'}
              </p>
            </div>
          </div>
        </div>

        {/* Sub-section b */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            b. If the chair is also a senior executive, what specific role do they hold within the organization's management structure?
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {excutiveRole || '-'}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2-12 */}
      <div className={styles.container}>
        {/* Main Heading */}
        <h1 className={styles.mainHeading}>
          2-12 ROLE OF THE HIGHEST GOVERNANCE BODY IN OVERSEEING THE MANAGEMENT OF IMPACTS
        </h1>

        {/* Sub-section a */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            a. Describe the role of the highest governance body and of senior executives in developing, approving, and updating the organization's purpose, value or mission statements, strategies, policies, and goals related to sustainable development
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {stakeholderEngagement || '-'}
              </p>
            </div>
          </div>
        </div>

        {/* Sub-section b */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            b. Describe the role of the highest governance body in overseeing the organization's due diligence and other processes to identify and manage the organization's impacts on the economy, environment, and people.
          </p>

          <div className={styles.questionsContainer}>
            {/* Question i */}
            <div className={styles.questionBox}>
              <p className={styles.questionTitle}>
                i. Describe how the highest governance body engages with stakeholders to support these processes.
              </p>
              <p className={styles.questionAnswer}>
                {stakeholderFeedbackInDecisionMaking?.engagement || '-'}
              </p>
            </div>

            {/* Question ii */}
            <div className={styles.questionBox}>
              <p className={styles.questionTitle}>
                ii. Describe how the highest governance body consider the outcomes and feedback gathered from stakeholder engagement in its decision-making regarding sustainability impacts.
              </p>
              <p className={styles.questionAnswer}>
                {stakeholderFeedbackInDecisionMaking?.feedback || '-'}
              </p>
            </div>
          </div>
        </div>

        {/* Sub-section c */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            c. Describe how does the highest governance body reviews the effectiveness of the organization's processes for managing its sustainability impacts as described previously and what specific aspects of these processes are reviewed (e.g., risk identification, mitigation strategies, performance monitoring).
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {governanceBodyEffectivenessReview || '-'}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2-13 */}
      <div className={styles.container}>
        {/* Main Heading */}
        <h1 className={styles.mainHeading}>
          2-13 DELEGATION OF RESPONSIBILITY FOR MANAGING IMPACTS
        </h1>

        {/* Sub-section a */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            a. Describe how the highest governance body delegates responsibility for managing the organization's impacts on the economy, environment, and people.
          </p>

          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {governanceBodyDelegationOfResponsibility?.seniorExecutivesDeveloping || '-'}
              </p>
            </div>

            {/* Question i */}
            <div className={styles.questionBox}>
              <p className={styles.questionTitle}>
                i. Describe if the highest governance body has appointed any senior executives with specific responsibility for managing the organization's impacts on the economy, environment, and people e.g., Chief Sustainability Officer, ESG Committee Chair.
              </p>
              <p className={styles.questionAnswer}>
                {governanceBodyDelegationOfResponsibility?.seniorExecutiveResponsibilityRole || '-'}
              </p>
            </div>

            {/* Question ii */}
            <div className={styles.questionBox}>
              <p className={styles.questionTitle}>
                ii. Describe if the highest governance body has delegated responsibility for managing these sustainability impacts to other employees beyond the senior executive level and at what level of the organization is this responsibility delegated (e.g., departmental, operational).
              </p>
              <p className={styles.questionAnswer}>
                {governanceBodyDelegationOfResponsibility?.responsibilityDelegatedToEmployees || '-'}
              </p>
            </div>
          </div>
        </div>

        {/* Sub-section b */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            b. Describe the process and frequency for senior executives or other employees to report back to the highest governance body on the management of the organization's impacts on the economy, environment, and people.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {reportingToGovernanceBodyFrequency || '-'}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2-14 */}
      <div className={styles.container}>
        {/* Main Heading */}
        <h1 className={styles.mainHeading}>
          2-14 ROLE OF THE HIGHEST GOVERNANCE BODY IN SUSTAINABILITY REPORTING
        </h1>

        {/* Sub-section a */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            a. Describe whether the highest governance body hold the responsibility for reviewing and approving the reported sustainability information, including the organization's identified material topics and if so, please describe the specific process the highest governance body follows for reviewing and approving this information.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {approvalProcess || '-'}
              </p>
            </div>
          </div>
        </div>

        {/* Sub-section b */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            b. If the highest governance body is not responsible for reviewing and approving the reported sustainability information, including material topics, please explain the reason for this structure and who is then responsible for reviewing and approving this information?
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {responsibilityForSustainabilityInfo || '-'}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2-15 */}
      <div className={styles.container}>
        {/* Main Heading */}
        <h1 className={styles.mainHeading}>
          2-15 CONFLICTS OF INTEREST
        </h1>

        {/* Sub-section a */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            a. Describe the processes for the highest governance body to ensure that conflicts of interest are prevented and mitigated.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {interestPrevention || '-'}
              </p>
            </div>
          </div>
        </div>

        {/* Sub-section b */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            b. Describe the process and frequency for senior executives or other employees to report back to the highest governance body on the management of the organization's impacts on the economy, environment, and people.
          </p>

          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {stakeholderConflictDisclosure?.disConflictsOfInterest || '-'}
              </p>
            </div>

            {/* Question i */}
            <div className={styles.questionBox}>
              <p className={styles.questionTitle}>
                i. Describe whether the organization report instances where members of the highest governance body also hold board positions with other organizations that may have business dealings with it's organization and how are the conflicts of interest is reported to stakeholders.
              </p>
              <p className={styles.questionAnswer}>
                {stakeholderConflictDisclosure?.boardPositionsWithOtherOrganizations || '-'}
              </p>
            </div>

            {/* Question ii */}
            <div className={styles.questionBox}>
              <p className={styles.questionTitle}>
                ii. Describe whether the organization disclose any significant cross-shareholding arrangements with suppliers, customers, or other stakeholders that could create potential conflicts and how are the conflicts of interest is reported to stakeholders.
              </p>
              <p className={styles.questionAnswer}>
                {stakeholderConflictDisclosure?.crossShareholdingDisclosure || '-'}
              </p>
            </div>

            {/* Question iii */}
            <div className={styles.questionBox}>
              <p className={styles.questionTitle}>
                iii. Describe whether there are any controlling shareholders in the organization, and how does the organization report on the nature of their control and potential conflicts arising from it. Report how are the conflicts of interest reported to stakeholders.
              </p>
              <p className={styles.questionAnswer}>
                {stakeholderConflictDisclosure?.controllingShareholdersAndConflicts || '-'}
              </p>
            </div>

            {/* Question iv */}
            <div className={styles.questionBox}>
              <p className={styles.questionTitle}>
                iv. Describe whether the organization disclose information about related parties (e.g., affiliates, subsidiaries), their relationships with the organization, any transactions conducted with them, and any outstanding balances owed to or from them?
              </p>
              <p className={styles.questionAnswer}>
                {stakeholderConflictDisclosure?.relatedPartyTransactionsDisclosure || '-'}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2-16 */}
      <div className={styles.container}>
        {/* Main Heading */}
        <h1 className={styles.mainHeading}>
          2-16 COMMUNICATION OF CRITICAL CONCERNS
        </h1>

        {/* Sub-section a */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            a. Describe whether and how critical concerns are communicated to the highest governance body.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {criticalConcernsReported || '-'}
              </p>
            </div>
          </div>
        </div>

        {/* Sub-section b */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            b. Describe whether any critical concerns communicated to the highest governance body during the most recent reporting period and if critical concerns were received, please report the total number of concerns received and, if possible, a general categorization of the nature of these concerns (e.g., financial irregularities, environmental violations, safety hazards).
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {criticalConcernsSummary || '-'}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2-17 */}
      <div className={styles.container}>
        {/* Main Heading */}
        <h1 className={styles.mainHeading}>
          2-17 COLLECTIVE KNOWLEDGE OF THE HIGHEST GOVERNANCE BODY
        </h1>

        {/* Sub-section a */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            a. Describe the specific measures taken by the organization to advance the collective knowledge, skills, and experience of the highest governance body on sustainable development topics.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {measuresToEnhanceGovernanceBodyKnowledge || '-'}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2-18 */}
      <div className={styles.container}>
        {/* Main Heading */}
        <h1 className={styles.mainHeading}>
          2-18 EVALUATION OF THE PERFORMANCE OF THE HIGHEST GOVERNANCE BODY
        </h1>

        {/* Sub-section a */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            a. Describe the specific measures taken by the organization to advance the collective knowledge, skills, and experience of the highest governance body on sustainable development topics.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {devlopmentTopics || '-'}
              </p>
            </div>
          </div>
        </div>

        {/* Sub-section b */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            b. Describe whether the evaluations of the highest governance body's performance conducted by an independent body or process. If not independent, how is objectivity ensured during the evaluation. And report how often these evaluations are conducted (annually/ biannually) etc.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {independentEvaluationBody || '-'}
              </p>
            </div>
          </div>
        </div>

        {/* Sub-section c */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            c. Describe actions taken in response to the evaluations, including changes to the composition of the highest governance body and organizational practices.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {actionsTakenInResponseToEvaluations || '-'}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2-19 */}
      <div className={styles.container}>
        {/* Main Heading */}
        <h1 className={styles.mainHeading}>
          2-19 REMUNERATION POLICIES
        </h1>

        {/* Sub-section a */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            a. Describe the remuneration policies for members of the highest governance body and senior executives, including: fixed pay and variable pay; sign-on bonuses or recruitment incentive payments; termination payments; clawbacks; retirement benefits.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {incentivesAndBenefits || '-'}
              </p>
            </div>
          </div>
        </div>

        {/* Sub-section b */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            b. Describe how the remuneration policies for members of the highest governance body and senior executives relate to their objectives and performance in relation to the management of the organization's impacts on the economy, environment, and people.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {performanceRelatedRemuneration || '-'}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2-20 */}
      <div className={styles.container}>
        {/* Main Heading */}
        <h1 className={styles.mainHeading}>
          2-20 PROCESS TO DETERMINE REMUNERATION
        </h1>

        {/* Sub-section a */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            a. Describe the process for designing organization's remuneration policies and for determining remuneration.
          </p>

          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {remunerationPolicyDesign?.remunerationPolicies || '-'}
              </p>
            </div>

            {/* Question i */}
            <div className={styles.questionBox}>
              <p className={styles.questionTitle}>
                i. Describe whether an independent committee or specific board members oversee the process for determining remuneration for the highest governance body and senior executives.
              </p>
              <p className={styles.questionAnswer}>
                {remunerationPolicyDesign?.remunerationOversight || '-'}
              </p>
            </div>

            {/* Question ii */}
            <div className={styles.questionBox}>
              <p className={styles.questionTitle}>
                ii. Describe how does the organization seek and take into consideration the views of stakeholders (including shareholders) regarding remuneration policies.
              </p>
              <p className={styles.questionAnswer}>
                {remunerationPolicyDesign?.shareholderVotesOnRemuneration || '-'}
              </p>
            </div>

            {/* Question iii */}
            <div className={styles.questionBox}>
              <p className={styles.questionTitle}>
                iii. Describe whether does the organization utilize independent remuneration consultants to assist in determining compensation. If so, how is their independence from the organization, board, and executives ensured.
              </p>
              <p className={styles.questionAnswer}>
                {remunerationPolicyDesign?.independentConsultants || '-'}
              </p>
            </div>
          </div>
        </div>

        {/* Sub-section b */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            b. Describe whether does the organization hold shareholder votes on remuneration policies or proposals. If so, please report the results of the most recent vote.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {remunerationVoteResults || '-'}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2-21 */}
      <div className={styles.container}>
        {/* Main Heading */}
        <h1 className={styles.mainHeading}>
          2-21 ANNUAL TOTAL COMPENSATION RATIO
        </h1>

        {/* Sub-section a */}
        <ReportTable
          title="a. Report the ratio of the annual total compensation for the organization's highest-paid individual to the median annual total compensation for all employees (excluding the highest-paid individual)"
          columns={annualCompensationRatioColumns}
          rows={annualCompensationRatioRows}
          showSerialNumber={false}
        />

        {/* Sub-section b */}
        <ReportTable
          title="b. Report the ratio of the percentage increase in annual total compensation for the organization's highest-paid individual to the median percentage increase in annual total compensation for all employees (excluding the highest-paid individual)"
          columns={percentageIncreaseRatioColumns}
          rows={percentageIncreaseRatioRows}
          showSerialNumber={false}
        />

        {/* Sub-section c */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            c. Is there any additional contextual information that helps to understand the reported ratios (like Whether full-time equivalent (FTE) pay rates are used for each part-time employee, A list of the types of compensation included, The title of the highest-paid individual).
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {additionalContextualInformation || '-'}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2-22 */}
      <div className={styles.container}>
        {/* Main Heading */}
        <h1 className={styles.mainHeading}>
          2-22 STATEMENT ON SUSTAINABLE DEVELOPMENT STRATEGY
        </h1>

        {/* Sub-section a */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            a. Please provide a statement from the highest governance body (board of directors) or the most senior executive outlining the relevance of sustainable development to the organization and its strategy for contributing to achieving it.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {devlopmentStrategy || '-'}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2-23 */}
      <div className={styles.container}>
        {/* Main Heading */}
        <h1 className={styles.mainHeading}>
          2-23 POLICY COMMITMENTS
        </h1>

        {/* Sub-section a */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            a. Describe the key principles or commitments outlined in organization's responsible business conduct policy (Sustainability policy outlines values, principles & development process with internal/external expertise).
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {responsibleBusinessConductCommitments?.businessConductPolicy || '-'}
              </p>
            </div>

            {/* Question i */}
            <div className={styles.questionBox}>
              <p className={styles.questionTitle}>
                i. Describe the authoritative intergovernmental instruments your organization's responsible business conduct policy references (These might include international conventions, declarations, or principles established by organizations like the United Nations (UN) or the Organization for Economic Co-operation and Development (OECD)).
              </p>
              <p className={styles.questionAnswer}>
                {responsibleBusinessConductCommitments?.OECD || '-'}
              </p>
            </div>

            {/* Question ii */}
            <div className={styles.questionBox}>
              <p className={styles.questionTitle}>
                ii. Describe whether organization's policy require the organization to conduct due diligence to identify, assess, and manage potential social, environmental, and human rights impacts throughout its operations and supply chain. If yes, please provide explanation and procedure.
              </p>
              <p className={styles.questionAnswer}>
                {responsibleBusinessConductCommitments?.dueDiligenceProcedure || '-'}
              </p>
            </div>

            {/* Question iii */}
            <div className={styles.questionBox}>
              <p className={styles.questionTitle}>
                iii. Describe whether organization's policy commit the organization to applying the precautionary principle, meaning taking proactive measures to avoid potential environmental harm even when scientific knowledge is incomplete. If yes, please provide explanation and procedure.
              </p>
              <p className={styles.questionAnswer}>
                {responsibleBusinessConductCommitments?.precautionaryPrincipleCommitment || '-'}
              </p>
            </div>

            {/* Question iv */}
            <div className={styles.questionBox}>
              <p className={styles.questionTitle}>
                iv. Describe whether policy explicitly state the organization's commitment to respecting human rights throughout its operations and supply chain, aligned with internationally recognized human rights principles. If yes, please explain.
              </p>
              <p className={styles.questionAnswer}>
                {responsibleBusinessConductCommitments?.humanRightsCommitment || '-'}
              </p>
            </div>
          </div>
        </div>

        {/* Sub-section b */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            b. Describe organization's specific policy commitment to respect human rights.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {specificHumanRightsPolicy?.policyCommitment || '-'}
              </p>
            </div>

            {/* Question i */}
            <div className={styles.questionBox}>
              <p className={styles.questionTitle}>
                i. Describe whether organization's policy on respecting human rights explicitly reference internationally recognized human rights frameworks, such as the Universal Declaration of Human Rights or the core labor standards of the International Labour Organization (ILO). Please provide with description.
              </p>
              <p className={styles.questionAnswer}>
                {specificHumanRightsPolicy?.humanRightsFrameworkReferences || '-'}
              </p>
            </div>

            {/* Question ii */}
            <div className={styles.questionBox}>
              <p className={styles.questionTitle}>
                ii. Describe whether organization's human rights policy identify specific categories of stakeholders, including at-risk or vulnerable groups, that the organization pays particular attention to in its efforts to respect human rights. Please provide with description.
              </p>
              <p className={styles.questionAnswer}>
                {specificHumanRightsPolicy?.stakeholderIdentificationHumanRights || '-'}
              </p>
            </div>
          </div>
        </div>

        {/* Sub-section c */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            c. Provide links to the policy commitments if publicly available, or, if the policy commitments are not publicly available, explain the reason for this.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {policyCommitmentLinks || '-'}
              </p>
            </div>
          </div>
        </div>

        {/* Sub-section d */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            d. Report at what level within the organization were these human rights policy commitments approved? Was this approval at the most senior level, such as the board of directors.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {approvalLevelHumanRightsCommitment || '-'}
              </p>
            </div>
          </div>
        </div>

        {/* Sub-section e */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            e. Report the extent to which the policy commitments apply to the organization's activities and to its business relationships.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {policyCommitmentScope || '-'}
              </p>
            </div>
          </div>
        </div>

        {/* Sub-section f */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            f. Describe how the policy commitments are communicated to workers, business partners, and other relevant parties.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {policyCommitmentCommunication || '-'}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2-24 */}
      <div className={styles.container}>
        {/* Main Heading */}
        <h1 className={styles.mainHeading}>
          2-24 EMBEDDING POLICY COMMITMENTS
        </h1>

        {/* Sub-section a */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            a. Describe how organization embeds each of its policy commitments for responsible business conduct throughout its activities and business relationships.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {responsibilityAllocation?.conductTroughtoutBusiness || '-'}
              </p>
            </div>

            {/* Question i */}
            <div className={styles.questionBox}>
              <p className={styles.questionTitle}>
                i. Describe how organization allocates responsibility to implement the commitments across different levels within the organization.
              </p>
              <p className={styles.questionAnswer}>
                {responsibilityAllocation?.allocatesResponbiltity || '-'}
              </p>
            </div>

            {/* Question ii */}
            <div className={styles.questionBox}>
              <p className={styles.questionTitle}>
                ii. Describe how organization integrates the commitments into organizational strategies, operational policies, and operational procedures
              </p>
              <p className={styles.questionAnswer}>
                {responsibilityAllocation?.commitmentIntegrationStrategies || '-'}
              </p>
            </div>

            {/* Question iii */}
            <div className={styles.questionBox}>
              <p className={styles.questionTitle}>
                iii. Describe how organization implements its commitments with and through its business relationships.
              </p>
              <p className={styles.questionAnswer}>
                {responsibilityAllocation?.busineessRelationShip || '-'}
              </p>
            </div>

            {/* Question iv */}
            <div className={styles.questionBox}>
              <p className={styles.questionTitle}>
                iv. Describe training programs or initiatives that the organization provide to equip its employees with the knowledge and skills to implement the responsible business conduct commitments effectively.
              </p>
              <p className={styles.questionAnswer}>
                {responsibilityAllocation?.busineesConductEffectively || '-'}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2-25 */}
      <div className={styles.container}>
        {/* Main Heading */}
        <h1 className={styles.mainHeading}>
          2-25 PROCESSES TO REMEDIATE NEGATIVE IMPACTS
        </h1>

        {/* Sub-section a */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            a. Describe organization's commitments to provide for or cooperate in the remediation of negative impacts that the organization identifies it has caused or contributed to. Please provide with description.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {remediationCommitments || '-'}
              </p>
            </div>
          </div>
        </div>

        {/* Sub-section b */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            b. Describe organization's approach to identify and address grievances, including the grievance mechanisms that the organization has established or participates in. These could include internal hotlines, complaint procedures, or participation in third-party grievance mechanisms set up by industry associations or government bodies.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {grievanceMechanisms || '-'}
              </p>
            </div>
          </div>
        </div>

        {/* Sub-section c */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            c. Describe other processes by which the organization provides for or cooperates in the remediation of negative impacts that it identifies it has caused or contributed to. This might involve community engagement programs or dialogue processes to address broader social or environmental issues.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {remediationProcesses || '-'}
              </p>
            </div>
          </div>
        </div>

        {/* Sub-section d */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            d. Describe how the stakeholders who are the intended users of the grievance mechanisms are involved in the design, review, operation, and improvement of these mechanisms. This could involve consultations, feedback loops, or representation on grievance committees.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {stakeholderInvolvementGrievance || '-'}
              </p>
            </div>
          </div>
        </div>

        {/* Sub-section e */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            e. Describe how the organization tracks the effectiveness of the grievance mechanisms and other remediation processes, and report examples of their effectiveness, including stakeholder feedback.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {grievanceMechanismEffectiveness || '-'}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2-26 */}
      <div className={styles.container}>
        {/* Main Heading */}
        <h1 className={styles.mainHeading}>
          2-26 MECHANISMS FOR SEEKING ADVICE AND RAISING CONCERNS
        </h1>

        {/* Sub-section a */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            a. Provide the following information:
          </p>
          <div className={styles.questionsContainer}>
            {/* Question i */}
            <div className={styles.questionBox}>
              <p className={styles.questionTitle}>
                i. Describe the mechanisms for individuals to seek advice on implementing the organization's policies and practices for responsible business conduct.
              </p>
              <p className={styles.questionAnswer}>
                {adviceMechanisms || '-'}
              </p>
            </div>

            {/* Question ii */}
            <div className={styles.questionBox}>
              <p className={styles.questionTitle}>
                ii. Describe the mechanisms for individuals to raise concerns about the organization's business conduct.
              </p>
              <p className={styles.questionAnswer}>
                {concernRaisingMechanisms || '-'}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2-27 */}
      <div className={styles.container}>
        {/* Main Heading */}
        <h1 className={styles.mainHeading}>
          2-27 COMPLIANCE WITH LAWS AND REGULATIONS
        </h1>

        {/* Sub-section a */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            a. Report the total number of significant instances of non-compliance with laws and regulations during the reporting period.
          </p>
          <div className={styles.tableContainer}>
            <table className={styles.table}>
              <thead className={styles.tableHeader}>
                <tr>
                  <th className={styles.tableHeaderCell}>S.No.</th>
                  <th className={styles.tableHeaderCell}>Category</th>
                  <th className={styles.tableHeaderCell}>Number of significant instance</th>
                </tr>
              </thead>
              <tbody>
                <tr className={styles.tableRow}>
                  <td className={styles.tableCell}>a.</td>
                  <td className={styles.tableCell}>Total Significant Instances of Non-Compliance</td>
                  <td className={`${styles.tableCell} ${styles.tableCellCenter}`}>
                    {totalNonComplianceInstances?.totalValue || '-'}
                  </td>
                </tr>
                <tr className={styles.tableRowEven}>
                  <td className={styles.tableCell}>b.</td>
                  <td className={styles.tableCell}>Instances for which fines were incurred</td>
                  <td className={`${styles.tableCell} ${styles.tableCellCenter}`}>
                    {totalNonComplianceInstances?.monetory || '-'}
                  </td>
                </tr>
                <tr className={styles.tableRow}>
                  <td className={styles.tableCell}>c.</td>
                  <td className={styles.tableCell}>Instances for which non-monetary sanctions were incurred</td>
                  <td className={`${styles.tableCell} ${styles.tableCellCenter}`}>
                    {totalNonComplianceInstances?.nonmonetory || '-'}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Sub-section b */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            b. Report the total number and the monetary value of fines for instances of non-compliance with laws and regulations that were paid during the reporting period.
          </p>
          <div className={styles.tableContainer}>
            <table className={styles.table}>
              <thead className={styles.tableHeader}>
                <tr>
                  <th className={styles.tableHeaderCell}>S.No.</th>
                  <th className={styles.tableHeaderCell}>Category</th>
                  <th className={styles.tableHeaderCell}>Number fines</th>
                  <th className={styles.tableHeaderCell}>Monetary value of fines(in currency)</th>
                </tr>
              </thead>
              <tbody>
                <tr className={styles.tableRow}>
                  <td className={styles.tableCell}>a.</td>
                  <td className={styles.tableCell}>Total Significant Instances of Non-Compliance</td>
                  <td className={`${styles.tableCell} ${styles.tableCellCenter}`}>
                    {numberOfFines?.total || '-'}
                  </td>
                  <td className={`${styles.tableCell} ${styles.tableCellCenter}`}>
                    {monetoryValue?.total || '-'}
                  </td>
                </tr>
                <tr className={styles.tableRowEven}>
                  <td className={styles.tableCell}>b.</td>
                  <td className={styles.tableCell}>Fines for non-compliance in the current reporting period</td>
                  <td className={`${styles.tableCell} ${styles.tableCellCenter}`}>
                    {numberOfFines?.currentPeriod || '-'}
                  </td>
                  <td className={`${styles.tableCell} ${styles.tableCellCenter}`}>
                    {monetoryValue?.currentPeriod || '-'}
                  </td>
                </tr>
                <tr className={styles.tableRow}>
                  <td className={styles.tableCell}>c.</td>
                  <td className={styles.tableCell}>Fines for non-compliance in previous reporting periods</td>
                  <td className={`${styles.tableCell} ${styles.tableCellCenter}`}>
                    {numberOfFines?.previousPeriod || '-'}
                  </td>
                  <td className={`${styles.tableCell} ${styles.tableCellCenter}`}>
                    {monetoryValue?.previousPeriod || '-'}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Sub-section c */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            c. Describe the significant instances of non-compliance with laws and regulations that occurred during the reporting period. Significant non-compliance reports should include location, issue type (e.g., tax fraud, spill), and context for user understanding. Recurring instances can be explained.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {significantNonComplianceInstances || '-'}
              </p>
            </div>
          </div>
        </div>

        {/* Sub-section d */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            d. Describe how organization has determined significant instances of non-compliance. The organization can assess severity of impact and consider external sector benchmarks to identify significant non-compliance instances.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {nonComplianceSeverityAssessment || '-'}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2-28 */}
      <div className={styles.container}>
        {/* Main Heading */}
        <h1 className={styles.mainHeading}>
          2-28 MEMBERSHIP ASSOCIATIONS
        </h1>

        {/* Sub-section a */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            a. Please disclose the industry associations, other membership associations, and national or international advocacy organizations in which the organization plays a significant role. This could include board memberships, active participation in committees or working groups, or other substantial involvement.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {membershipAssociations || '-'}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2-29 */}
      <div className={styles.container}>
        {/* Main Heading */}
        <h1 className={styles.mainHeading}>
          2-29 APPROACH TO STAKEHOLDER ENGAGEMENT
        </h1>

        {/* Sub-section a */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            a. Describe organization's approach to engaging with its stakeholders.
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {approachengaging || '-'}
              </p>
            </div>

            {/* Question i */}
            <div className={styles.questionBox}>
              <p className={styles.questionTitle}>
                i. Describe the categories of stakeholders organization engage with and how does the organization identify its key stakeholders. Explain if there's any specific process or methodology used.
              </p>
              <p className={styles.questionAnswer}>
                {specifyMethodlogyUse || '-'}
              </p>
            </div>

            {/* Question ii */}
            <div className={styles.questionBox}>
              <p className={styles.questionTitle}>
                ii. Describe the organization's main purposes for engaging with stakeholders.
              </p>
              <p className={styles.questionAnswer}>
                {stakeholderEngagementPurposes || '-'}
              </p>
            </div>

            {/* Question iii */}
            <div className={styles.questionBox}>
              <p className={styles.questionTitle}>
                iii. Describe how the organization seeks to ensure meaningful engagement with stakeholders.
              </p>
              <p className={styles.questionAnswer}>
                {meaningfulStakeholderEngagement || '-'}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2-30 */}
      <div className={styles.container}>
        {/* Main Heading */}
        <h1 className={styles.mainHeading}>
          2-30 COLLECTIVE BARGAINING AGREEMENTS
        </h1>

        {/* Sub-section a */}
        <ReportTable
          title="a. Disclose the percentage of organization's total workforce that is covered by collective bargaining agreements."
          columns={collectiveBargainingColumns}
          rows={collectiveBargainingRows}
          showSerialNumber={false}
        />

        {/* Sub-section b */}
        <div className={styles.consolidatingSection}>
          <p className={`${styles.consolidatingTitle} common_text_style`}>
            b. Describe whether the working conditions and terms of employment for non-union employees reference collective bargaining agreements from other organizations in the industry or sector. If so, please specify which types of agreements are used as a reference?
          </p>
          <div className={styles.questionsContainer}>
            <div className={styles.questionBox}>
              <p className={styles.questionAnswer}>
                {referencedAgreementsTypes || '-'}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default GRI2021
